import { initGraphQLTada } from 'gql.tada'
import { introspection } from './school-gql/generated/graphql-env'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    ISO8601DateTime: string
    ISO8601Date: string
    JSON: any
    BigInt: string
  }
}>()
